<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  campaigns: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['merge', 'clear']);

const { t } = useI18n();

// Campaigns::MergeService refuses a merge across inboxes: a campaign belongs to the inbox it went
// out through. Saying so here beats letting the dialog fail on confirm.
const isSameInbox = computed(
  () => new Set(props.campaigns.map(campaign => campaign.inbox?.id)).size === 1
);

const canMerge = computed(
  () => props.campaigns.length > 1 && isSameInbox.value
);

const hint = computed(() => {
  if (props.campaigns.length < 2) return t('CAMPAIGN.MERGE.SELECTION.HINT_MIN');

  return isSameInbox.value ? '' : t('CAMPAIGN.MERGE.SELECTION.HINT_SAME_INBOX');
});
</script>

<template>
  <div class="flex flex-wrap items-center gap-2">
    <span class="text-sm text-n-slate-11">
      {{
        t(
          'CAMPAIGN.MERGE.SELECTION.COUNT',
          { count: campaigns.length },
          campaigns.length
        )
      }}
    </span>
    <Button
      size="sm"
      variant="faded"
      color="slate"
      icon="i-lucide-merge"
      :label="t('CAMPAIGN.MERGE.SELECTION.ACTION')"
      :disabled="!canMerge"
      @click="emit('merge')"
    />
    <Button
      size="sm"
      variant="ghost"
      color="slate"
      :label="t('CAMPAIGN.MERGE.SELECTION.CLEAR')"
      @click="emit('clear')"
    />
    <span v-if="hint" class="text-xs text-n-slate-11">{{ hint }}</span>
  </div>
</template>
